import {getTypeOfObject, isObject, setObject} from "./objectHelper";
import {generateRandomNumber} from "./numberHelper";
import {from} from "linq-to-typescript";
import {percantageItem} from "./interface";
import {percantageFixer} from "./percantageHelper";

/**
 * Belirtilen dizinin dolu olup olmadığını kontrol eder.
 * array: Kontrol edilecek dizi.
 * Çıkış:
 * true → Dizi doluysa.
 * false → Dizi boşsa.*/
export const isArrayHaveItem = (array: any) => {
    return array !== null && array !== undefined && Array.isArray(array) && array.length > 0;
}


export const isArraysEqual = (arrayOne: any[], arrayTwo: any[]) => {
    if (arrayOne === arrayTwo) return true;
    if (arrayOne == null || arrayTwo == null) return false;
    if (arrayOne.length !== arrayTwo.length) return false;

    for (let i = 0; i < arrayOne.length; ++i) {
        if (arrayOne[i] !== arrayTwo[i]) return false;
    }
    return true;
}
export const getItemByIndex = (array: any, index: number) => {
    if (isArrayHaveItem(array)) {
        if (array.length > index) {
            return array[index];
        }
    }
    return undefined;
}
export  const generateNumberList =(count:number,number = 0)=>{

    const tempArray:number[] = [];
    for (let i = 0; i < count; i++) {

        tempArray.push(number);
    }
    return tempArray;
}

export type numberGeneraterWithPerType = {number? : number}&percantageItem;
export  const generateMultiNumberListPercantage =(count :number,listInfo:numberGeneraterWithPerType[])=>{

    const tempList:number[] =[];
    const fixListInfo = percantageFixer(listInfo) as numberGeneraterWithPerType[];
    for (const info of fixListInfo) {
        const {number = 0,percentage  } = info
        const  count = Math.floor((number  * percentage) /100);
        tempList.push.apply(generateNumberList(count,number));
    }
    if (count > tempList.length) {

        const missingElement = count - tempList.length;
        const tempAgeArray = generateNumberList(missingElement, fixListInfo[0].number);
        tempList.push.apply(tempAgeArray);
    }
    return tempList;
}
export  const generateMultiNumberList =(listInfo:{count:number,number? : number}[])=>{

    const tempList:number[] =[];
    for (const info of listInfo) {
        const {number = 0,count  } = info
        tempList.push.apply(generateNumberList(count,number));
    }
    return tempList;
}

export const generateRandomNumberList = (count: number, min: number, max: number, unique: boolean) => {
    if (min >= max) {
        return [];
    }
    const tempArray:number[] = [];
    if (unique) {
        //let tempCount = count;
        if(count >= (max - min)){
            for (let i = min; i < max; i++) {
                tempArray.push(i);
            }
        } else {

            const generateNumber:number[] = [];

            //diyelim 13 haneli bir liste
            //3 haneyi kaldırdın 3 ü kaldırdın eleman sayısı 13  sonuç 1,2,4,5,6,7,8,9,10,11,12,13
            //sonra 5 haneyi kaldırdın kaldırdığın değer 6 nolu değer eleman sayısı 12 1,2,4,5,7,8,9,10,11,12,13
            //sonra 7 haneyi kaldırdın kaldırdığın değer 9 nolu değer eleman sayısı 11 1,2,4,5,7,8,10,11,12,13
            //sonra 7 haneyi kaldırdın kaldırdığın değer 10 nolu değer eleman sayısı 10  1,2,4,5,7,8,11,12,13
            //2 haneyi kaldırdın 2 1,4,5,7,8,11,12,13
            for (let i = 0; i < count; i++) {
                const randomNumber = generateRandomNumber(min,max);
                const addValue = from(generateNumber).where(x =>x < randomNumber).count();
                generateNumber.push(randomNumber);
                tempArray.push(addValue + randomNumber);
            }
            return  tempArray;
        }
    }else{
        for (let i = 0; i < count; i++) {
            const randomNumber = generateRandomNumber(min,max);
            tempArray.push(randomNumber);
        }

    }
    return  tempArray;
}

type getRandomElementArrayType  = <T=any>(count:number,array:T[])=>T[]|undefined;
export const getRandomElementArray:getRandomElementArrayType = (count, array) => {
    //const indexArray: number[] = [];

    if (!isArrayHaveItem(array)) {
        return [];
    }

    if (array.length === count) {
        return array;
    }
    if ((array.length / 2) > count) {
        const findElement: any[] = [];
        const indexList =generateRandomNumberList(count,0,array.length,true);
        for (const number of indexList) {
            findElement.push(array.at(number));
        }
        return  findElement;
    } else {
        const findElement: any[] = [];
        const indexList =generateRandomNumberList(array.length - count,0,array.length,true);
        let removeElementIndex =indexList.shift();
        for (let i = 0; i < array.length; i++) {
            if(removeElementIndex !== i){
                findElement.push(array.at(i));
            }else{
                removeElementIndex =indexList.shift();
            }
        }
        return  findElement;
    }
}

type getRandomElementType  = <T=any>(array:T[])=>T|undefined;
export  const getRandomElement:getRandomElementType = (array) => {
    if (isArrayHaveItem(array)) {
        const index = Math.floor(Math.random() * array.length);
        const element = array[index];
        return element;
    } else {
        return undefined;
    }


}
type removeItemWithIndexType = <T>(array:T[], index:number)=>T[]
export const removeItemWithIndex:removeItemWithIndexType =(array, index) => {
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
}


export const addListItemsId =(idField:string,items:any[])=>{

    return items.map((value, index) => {
        if(isObject(value)){
            setObject(value,idField,index,true);
        }
        return value;
    })
}
export const removeItems = (array: any[], itemsIndex: number[] = []) => {
    const sorted = [...itemsIndex]
        .filter(i => i >= 0 && i < array.length)
        .sort((a, b) => b - a);
    for (const idx of sorted) {
        array.splice(idx, 1);
    }
    return array;

}

type removeFirstItemType = <T>(array:T[], value:T)=>T[]
export const removeFirstItem:removeFirstItemType =(array, value) => {
    const index = array.indexOf(value);
   return removeItemWithIndex(array,index);
}


type removeFirstItemWithConditionType = <T>(array:T[], conditon:(listItem:T)=>boolean)=>T[]
export const removeFirstItemWithCondition:removeFirstItemWithConditionType =(array, conditon) => {
    for (let index = 0; index < array.length; index++) {
        if(conditon(array[index])){
            array.splice(index,1);
        }
    }
    return array;
}
type removeAllItemWithConditionType = <T>(array:T[], conditon:(listItem:T)=>boolean)=>T[]
export const removeAllItemWithCondition:removeAllItemWithConditionType =(array, conditon) => {
    let index = 0
    while (index < array.length) {
        if(conditon(array[index])){
            array.splice(index,1);
        }else{
            ++index;
        }
    }
    return array;
}

type removeAllItemType = <T>(array:T[], value:T)=>T[]
export const removeAllItem:removeAllItemType = (array, value) => {
    let index = 0;
    while (index < array.length) {
        if (array[index] === value) {
            array.splice(index, 1);
        } else {
            ++index;
        }
    }
    return array;
}

export const isArrayContains = (array: any, item: any) => {
    if (isArrayHaveItem(array)) {
        if (array.indexOf(item) >= 0) {
            return true;
        }
    }
    return false;
}
type convertArrayType = <T>(elements?: T | T[])=>T[]
export const convertArray:convertArrayType = <T=any>(elements?:T | T[]) => {
    if(elements !== undefined){
        return isArray(elements) ?
            elements as T[] :
             [elements as T];
    }else{
        return  [] as T[];
    }


}
export const isArray = (array: any) => {
    return Array.isArray(array);
}

export const clearListItem = (array: any): [] => {
    if (isArrayHaveItem(array)) {
        while (array.length > 0) {
            array.pop();
        }
    }
    return array as [];
}

type addListItemCheckContainsType = <T>(array:T[], item:T)=>T[]
export const addListItemCheckContains:addListItemCheckContainsType = (array, item) => {

    if (isArray(array)) {
        if (array.indexOf(item) < 0) {
            array.push(item);
        }
    } else {
        if (item !== undefined) {
            return [item];
        } else {
            return [];
        }
    }
    return array;
}

type addListCheckContainsType = <T>(array:T[], sourceArray:T[])=>T[]
export const addListCheckContains:addListCheckContainsType = (array , sourceArray) => {

    if (isArrayHaveItem(sourceArray)) {
        sourceArray.forEach(value => array = addListItemCheckContains(array, value));
    } else {
        return isArray(sourceArray) ? sourceArray ?? [] : [];
    }
    return array;
}
export const mergeListSafe = (arrayOne: any[] | any, arrayTwo: any[] | any): any[] => {
    if (isArrayHaveItem(arrayOne)) {
        let response:any[] = [];
        if (isArrayHaveItem(arrayTwo)) {
            response = [...arrayOne, ...arrayTwo];
        } else if (arrayTwo !== undefined) {
            if (isArray(arrayTwo)) {
                response = [...arrayOne];
            } else {
                response = [...arrayOne, arrayTwo];
            }

        } else {
            response = [...arrayOne];
        }
        return  response;
    } else if (isArrayHaveItem(arrayTwo)) {
        if (isArray(arrayOne) || arrayOne === undefined) {
            return [...arrayTwo];
        } else {
            const type = getTypeOfObject(arrayOne);
            if (type === "string" || type === "number") {
                return [arrayOne, ...arrayTwo];
            } else if (type === "object") {
                const tempArray: any[] = [];
                tempArray.push(arrayOne);
                for (const arrayTwoElement of arrayTwo) {
                    tempArray.push(arrayTwoElement);
                }
                return tempArray;
            } else {
                return [...arrayOne, ...arrayTwo];
            }

        }

    } else if (arrayTwo !== undefined) {
        if (isArray(arrayTwo)) {
            return arrayOne ?? [];
        } else {
            if (arrayOne !== undefined) {
                return [arrayOne, arrayTwo];
            } else {
                return [arrayTwo];
            }

        }

    } else {
        return [];
    }

}
export const reverseForeach = (obj: any[], f: (data: any, index: number) => boolean) => {

    if (isArrayHaveItem(obj)) {
        for (let i = obj.length - 1; i >= 0; i--) {
            if (f.call(obj, obj[i], i)) {
                break;
            }
        }
    }
}

export const getFirstListItemByFieldValue = (obj: object | any, desc: string, value: any) => {

    if (obj === undefined || obj === null || !Array.isArray(obj)) {
        return
    }

    const newDesc = desc.replaceAll('?', '') as string;
    let arr = newDesc.split('.') as any;
    let result;
    for (let index = 0; index < obj.length; index++) {
        result = obj[index];
        while (arr.length > 0) {

            result = result[arr.shift()]
        }
        arr = newDesc.split('.') as any;
        if (result === value) {
            return obj[index] as any;
        }
    }

    return {} as any
};